<template>
  <div class="chat-header" title="Drag to move">
    <div class="flex-start">
      <div>
        <img src="../svg/chat-bubble.svg" alt="ChatBubble" />
      </div>
      <div>
        <h3>Chat Assistant</h3>
        <p>Carbonite + Webroot support</p>
      </div>
    </div>
    <div>
      <button v-if="!chatBotStore.fullHeight" @click="chatBotStore.fullHeight = !chatBotStore.fullHeight">
        <img src="../svg/expand.svg" alt="Expand" />
      </button>
      <button v-else @click="chatBotStore.fullHeight = !chatBotStore.fullHeight">
        <img src="../svg/collapse.svg" alt="Collapse" />
      </button>
      <clear-history-btn />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();

import ClearHistoryBtn from "./clearHistoryBtn.vue";
</script>
